// transformers.js — Pure functions that shape data before submission

/**
 * Strips fields from packData.price based on group/datesType combos
 * to avoid sending irrelevant price fields to the backend.
 */
export const normalizePriceFields = (packData) => {
    const { group, datesType, price } = packData;

    if (group === 'backpacking' && datesType === 'fixed') {
        return price.map((item) => ({ ...item, meetupPoint: [] }));
    }

    if (datesType === 'custom') {
        return price.map((item) => ({
            ...item,
            pickupLocation: [],
            price: { actual: 0, reserve: 0, tax: 0, total: 0 }
        }));
    }

    if (datesType === 'fixed') {
        return price.map((item) => ({
            ...item,
            customPrice: { room: 0, groupPrice: 0, bed: 0, perPerson: 0, reserve: 0, vehicle: [] }
        }));
    }

    return price;
};

/**
 * Converts multiline textarea strings into trimmed string arrays.
 */
export const splitTextBlocks = (tempData) => ({
    included: tempData.included.split('\n').filter((line) => line.trim() !== ''),
    excluded: tempData.excluded.split('\n').filter((line) => line.trim() !== ''),
    terms: tempData.terms.split('\n').filter((line) => line.trim() !== ''),
    safety: tempData.safety.split('\n').filter((line) => line.trim() !== ''),
    carry: tempData.carry.split('\n').filter((line) => line.trim() !== '')
});
